export default __webpack_public_path__ + "static/media/three-fifth.d587dcab.svg";